$(document).ready(function () {
  const $slider = $('.hura-messages.swiper-wrapper');
  if (!$slider.length || $slider.hasClass('slick-initialized')) {
    return;
  }

  const autoplayEnabled = String($slider.data('autoplay')) !== 'false';
  const autoplaySpeed = (parseInt($slider.data('speed'), 10) || 5) * 1000;

  $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    arrows: true,
    rtl: true,
    autoplay: autoplayEnabled,
    autoplaySpeed: autoplaySpeed,
    pauseOnHover: true,
    pauseOnFocus: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  setTimeout(function () {
    const slickSlides = $slider.find('.slick-list .slick-slide');
    adaFormatSlickSlides(slickSlides);
  }, 250);

  $slider.show();
  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('setPosition');
  }
  customSlickSlider();
});
